<template>
  <nav class="panel pt-2 pb-2">
    <div class="panel-block" v-if="title.length">
      <div class="title mb-0">
        {{ title }}
      </div>
    </div>
    <div class="panel-block">
      <div class="has-text-grey is-flex-grow-1">
        <slot></slot>
      </div>
    </div>
    <footer v-if="footer" class="panel-footer" >
      <slot name="footer"></slot>
    </footer>
  </nav>
</template>

<script>
export default {
  name: "genexPanel",
  props:{
    title: {
      type: String,
      default() {
        return ""
      },
    },
    footer: {
      type: Boolean,
      default() {
        return false
      },
    },
  }
}
</script>

<style scoped>

</style>